import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { State } from "./editSpecification.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export type EditSpecificationPayload = {
  specificationId: number;
  updates: {
    description?: string;
    location?: string;
    subLocation?: string;
    quantity?: number;
    zone?: string;
    detectorResistance?: string;
    tamperResistance?: string;
    voltageSignalReading?: string;
  };
};

export const asyncMutations = {
  editSpecification: createAppAsyncThunk(
    "editSpecification/editSpecification",
    async (payload: EditSpecificationPayload, { rejectWithValue, extra: { sdk } }) => {
      const { specificationId, updates } = payload;

      if (!specificationId || !Object.keys(updates).length) {
        return rejectWithValue("Missing specificationId or update fields");
      }

      const response = await graphqlRequest(sdk.editSpecification, {
        thunkName: "editSpecification/editSpecification",
        variables: {
          specificationId,
          updates,
        },
      });

      const { data, errors } = response;

      if (errors) {
        return rejectWithValue(errors);
      }

      if (!data?.editSpecification) {
        return rejectWithValue("Failed to update specification");
      }

      return data.editSpecification;
    },
  ),
};

export const editSpecification = asyncMutations.editSpecification;

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder
    .addCase(asyncMutations.editSpecification.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(asyncMutations.editSpecification.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(asyncMutations.editSpecification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
};
